
export const LANGUAGE_STORAGE_KEY = 'InstrumentItemList:languageId';
export const LANGUAGE_DEFAULT_VAL = 'en';
